import React from 'react';
import Session from "../../../../services/Session";
import { SystemFeatureToggle } from "../../../../data/SystemFeatureToggle";
export default function Feature(props) {
    if (props.disabled || !Session.user.hasAnySystemFeature(props.hasAny.concat([SystemFeatureToggle.DEBUG]))) {
        return null;
    }
    return React.createElement(React.Fragment, null, props.children);
}
